import { render, staticRenderFns } from "./DoctorForm.vue?vue&type=template&id=678bb558&scoped=true&"
import script from "./DoctorForm.vue?vue&type=script&lang=js&"
export * from "./DoctorForm.vue?vue&type=script&lang=js&"
import style0 from "./DoctorForm.vue?vue&type=style&index=0&id=678bb558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678bb558",
  null
  
)

export default component.exports